( function( $ ) {
    //  keep track of training progress
    $('.basistraining-prev-next-container a').on('click', function(evt) {
        evt.preventDefault();

        var target = evt.currentTarget;
        var action = target.getAttribute('data-action');
        var postID = target.getAttribute('data-id');

        var data = localStorage.getItem('basistrainingCompleted');
        var arr = [];
        
        if (data) {
            arr = JSON.parse(data) || [];
        }
        if (arr.indexOf(postID) < 0) {
            arr.push(postID);
            localStorage.setItem('basistrainingCompleted', JSON.stringify(arr));
        }
        if (action) {
            window.location.assign(action);
        }
    });

    var data = localStorage.getItem('basistrainingCompleted');
    var arr = [];

    if (data) {
        arr = JSON.parse(data);
    }

    if (arr && arr.length) {

        arr.forEach(function(id) {
            $('[data-id="' + id + '"]').addClass('basistraining-item-done');
            $('[data-id="' + id + '"]').find('.basistraining-item-link').text('Nog een keer');
        });
    }
} )( jQuery );
